module.exports = __webpack_public_path__ + "static/media/logsNew.13c78aa3.svg";